<template>
    <div>
        <div class="modal-overlay active" @click="closeDialog()"></div>
        <div class="modal suggested-address-modal">
            <div class="modal__header">
                <h2 class="headline-s">Set Card as Default?</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div id="other_users" v-if="otherUsers.length > 0">
                <h2 class="headline-xs">Also Set Card as Default for Other Users?</h2>
                <p style="padding-bottom: 1rem;">The users below currently can place orders and have a different card saved in their default checkout options.</p>
                <Checkbox
                    v-if="otherUsers.length > 1" 
                    v-model="selectAllUsers"
                    @input="toggleAllUsers()" 
                    :label="`All Users (${otherUsers.length})`" 
                    labelClasses="title-s text-rothcoCharcoal" 
                    style="padding-bottom: 1rem;" 
                    id="all_users"
                />
                <div class="users-grid">
                    <div v-for="(user) in otherUsers" class="flex-column" :key="`company_user_${user.user_id}`" :id="`company_user_${user.user_id}`">
                        <Checkbox 
                            v-model="user.set_default" 
                            :label="user.email" 
                            labelClasses="title-s text-rothcoCharcoal" 
                            style="margin-right:1rem;" 
                            :id="`company_user_checkbox_${user.user_id}`"
                        />
                        <div style="padding: 0.5rem 0 0 1rem;">
                            <div v-if="user?.default_checkout_creditcard?.credit_card_id" class="flex-row-forced">
                                <span>
                                    <VisaIcon v-if="user?.default_checkout_creditcard.cc_type == 'Visa'" alt="visa-logo"/>
                                    <MasterCardIcon v-else-if="user?.default_checkout_creditcard.cc_type == 'MasterCard' || user?.default_checkout_creditcard.cc_type == 'Master Card'" alt="mastercard-logo"/>
                                    <AmexIcon v-else-if="user?.default_checkout_creditcard.cc_type == 'American Express'" alt="amex-logo"/>
                                    <DiscoverIcon v-else-if="user?.default_checkout_creditcard.cc_type == 'Discover'" alt="discover-logo"/>
                                </span>
                                &nbsp;
                                <p class="text-rothcoBlack">{{ user?.default_checkout_creditcard.cc_type }} &bull;&bull;&bull;&bull; {{ user?.default_checkout_creditcard.cc_last_4 }}</p>
                            </div>
                            <p v-else>
                                No Default Card
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="actions">
                <RothcoCta class="primary" id="submitButton" @click="submit()">Set as Default</RothcoCta>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { ref, computed, watch, inject } from "vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import CloseIcon from "@icons/closeIcon.svg";
    import Checkbox from "@/components/Checkbox.vue";
    import VisaIcon from "@icons/visa.svg";
    import MasterCardIcon from "@icons/mastercard.svg";
    import AmexIcon from "@icons/amex.svg";
    import DiscoverIcon from "@icons/discover.svg";

    const dialogRef = inject('dialogRef');

    const otherUsers = ref(dialogRef.value?.data?.otherUsers.map((user)=>({...user, set_default: 0})));

    const selectedUserIds = computed(()=>{
        return otherUsers.value?.filter((user)=>(user.set_default == 1))?.map((user)=>(user.user_id)) ?? []
    });
    watch(selectedUserIds, (newVal)=>{
        if(newVal.length == otherUsers.value.length){
            selectAllUsers.value = 1
        }else{
            selectAllUsers.value = 0;
        }
    }, {deep: true})

    const selectAllUsers = ref(0);
    const toggleAllUsers = ()=>{
        selectAllUsers.value = selectAllUsers.value ? 0 : 1;
        otherUsers.value.forEach((user,i)=>{
            otherUsers.value[i].set_default = selectAllUsers.value;
        })
    }
   
    const closeDialog = (data) => {
        dialogRef?.value?.close(data);
    }

    const submit = ()=>{
        closeDialog({ action: 'set_default', other_users: selectedUserIds.value });
    };
</script>
<style lang="scss" scoped>
    .modal {
        max-width: fit-content !important;
        min-width: 30rem;
    }
    .users-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
        overflow-y: scroll;
        max-height: 30vh;
    }
</style>